/**
 * @generated SignedSource<<97bb9114e3fa4dcfd8b10784726aa3fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type LicenseCreationInfoKind = "Admin" | "Converter" | "Order" | "Registration";
export type LicenseUsageKind = "Free" | "UsedForTree";
import { FragmentRefs } from "relay-runtime";
export type accountLicensesTable_LicenseFragment$data = {
  readonly creationInfo: {
    readonly createdAt: string;
    readonly creatorId?: string;
    readonly kind: LicenseCreationInfoKind;
    readonly licenseDefinition: {
      readonly data: {
        readonly name: string;
      };
    } | null;
    readonly orderId?: string;
    readonly userId?: string;
  };
  readonly id: string;
  readonly usage: {
    readonly at?: string;
    readonly forUser?: {
      readonly email: string;
    } | null;
    readonly kind: LicenseUsageKind;
  };
  readonly " $fragmentType": "accountLicensesTable_LicenseFragment";
};
export type accountLicensesTable_LicenseFragment$key = {
  readonly " $data"?: accountLicensesTable_LicenseFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"accountLicensesTable_LicenseFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "accountLicensesTable_LicenseFragment"
};

(node as any).hash = "9de9e1ec47739d9809dbf827f7f99442";

export default node;
